var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentManagerBackToCartera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 0.8C11.6 0.4 11.9 0 12.4 0H21.7C22.1 0 22.5 0.3 22.5 0.8V4.7H31C32.7 4.7 34.1 6.1 34.1 7.8V11.2L33 11.7C28.1 13.6 23.5 14.4 19.4 14.7V13.2C19.4 12.8 19.1 12.4 18.6 12.4H15.5C15.1 12.4 14.7 12.7 14.7 13.2V14.7C6.4 14.3 1.2 11.7 1.2 11.7L0 11.2V7.8C0 6.1 1.4 4.7 3.1 4.7H11.6V0.8ZM20.8 1.6H13.1V4.7H20.8V1.6ZM16.2 17.2V14.1H17.7V17.2H16.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2 21.3C23.8 20.7 24.8 21.1 24.8 22V25.9C27.9 26.3 30.8 27.3 33.1 28.6C33.6 28 33.9 27.3 33.9 26.5V13L33.4 13.2C28.3 15.1 23.5 16 19.2 16.3V18C19.2 18.4 18.9 18.8 18.4 18.8H15.3C14.9 18.8 14.5 18.5 14.5 18V16.4C6 16 0.4 13.2 0.4 13.2L0 13V26.6C0 28.3 1.4 29.7 3.1 29.7H14.8L23.2 21.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 27.2V23.2L16.9 29.6L23.3 36V32C30.8 32.6 36.9 36.5 38.4 41.6C38.6 40.8 38.7 40 38.7 39.2C38.8 33 32 27.9 23.3 27.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentManagerBackToCartera);
export default __webpack_public_path__ + "static/media/content-manager-back-to-cartera.5c825b14.svg";
export { ForwardRef as ReactComponent };